export enum TrackingTool {
  MMV_MATOMO_TAG_MANAGER = 'mmv_matomo_tag_manager',
}
export interface MatomoTrackingTool {
  tool: TrackingTool.MMV_MATOMO_TAG_MANAGER;
  matomoUrl: string;
}

export type TrackingToolConfig = MatomoTrackingTool;
